<template>
  <div class="bubble-row" :class="message.sender">
    <div class="bubble">
      <div class="meta">
        <div class="name">{{ message.name }}</div>
        <div class="time">{{ message.time }}</div>
      </div>
      <div class="text">{{ message.text }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  message: Object,
});
</script>

<style scoped>
.bubble-row {
  display: flex;
  margin-bottom: 26px;
}

.bubble-row.user {
  justify-content: flex-start;
}

.bubble-row.me {
  justify-content: flex-end;
}

.bubble {
  max-width: 420px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 0;
  padding: 14px 16px;
}

.meta {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 10px;
}

.name {
  font-weight: 600;
  color: #475569;
}

.time {
  font-size: 13px;
  color: #6b7280;
}

.text {
  font-size: 15px;
  color: #374151;
  line-height: 1.6;
}
</style>